Vue.component('alert', {
    props: ['message', 'type', 'errors'],

    template: `
        <div v-if="message.length > 0" class="alert" :class="{'alert-success': type == 'success', 'alert-danger': type == 'error'}">
            {{message}}
            <ul v-if="errors != undefined && errors.length > 0" class="mb-0">
                <li v-for="error in errors" v-text="error"></li>
            </ul>
        </div>
    `
});
